import { Alert, Button, Card, Descriptions, Divider, Space, Tag, Typography } from "antd";
import { useContext } from "react";
import AppContext from "../../../store/app.context";
import { useParams } from "react-router";

const IntegrationTab = ({ team, message }) => {
	const { teamId } = useParams();

	const handleGitHubConnect = () => {
		// Logic to initiate GitHub OAuth flow
		const installUrl = `https://github.com/apps/cloudiva-bot/installations/new?state=${teamId}`;
		// open in new tab
		window.open(installUrl, "_blank");
	};

	return (
		<Card title="Integrasi">
			{message && message === "github_success" ? (
				<Alert
					message="Berhasil menghubungkan ke GitHub!"
					type="success"
					showIcon
					style={{ marginBottom: 16 }}
				/>
			) : null}
			<Descriptions bordered column={1} size="small">
				<Descriptions.Item label="GitHub">
					<Space direction="horizontal">
						{team?.integrations?.github?.installationId ? (
							<>
								<Button disabled>Putuskan dari GitHub</Button>
								<Typography.Text code>
									Terhubung sebagai {team.integrations?.github?.account?.login}
								</Typography.Text>
							</>
						) : (
							<Button type="primary" onClick={handleGitHubConnect}>
								Hubungkan ke GitHub
							</Button>
						)}
					</Space>
				</Descriptions.Item>
				<Descriptions.Item label="GitLab (Coming Soon)">
					<Space direction="horizontal">
						<Button type="primary" disabled>
							Hubungkan ke GitLab
						</Button>
						<Button disabled>Putuskan dari GitLab</Button>
					</Space>
				</Descriptions.Item>
				<Descriptions.Item label="Bitbucket (Coming Soon)">
					<Space direction="horizontal">
						<Button type="primary" disabled>
							Hubungkan ke Bitbucket
						</Button>
						<Button disabled>Putuskan dari Bitbucket</Button>
					</Space>
				</Descriptions.Item>
				<Descriptions.Item label="Slack (Coming Soon)">
					<Space direction="horizontal">
						<Button type="primary" disabled>
							Hubungkan ke Slack
						</Button>
						<Button disabled>Putuskan dari Slack</Button>
					</Space>
				</Descriptions.Item>
			</Descriptions>
		</Card>
	);
};

export default IntegrationTab;
